import { db } from '../firebase';
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  doc,
  updateDoc,
  writeBatch,
  limit,
} from 'firebase/firestore';

const notificationService = {
  /**
   * Écoute les notifications en temps réel
   */
  subscribe(uid, callback, onError) {
    const q = query(
      collection(db, 'notifications'),
      where('toUserId', '==', uid),
      orderBy('createdAt', 'desc'),
      limit(50)
    );

    return onSnapshot(
      q,
      (snapshot) => {
        const notifications = snapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        const unreadCount = notifications.filter((n) => !n.read).length;
        callback({ notifications, unreadCount });
      },
      (err) => {
        console.error('notificationService.subscribe error:', err);
        if (onError) onError(err);
      }
    );
  },

  // Création de notifications exclusivement côté serveur (Cloud Functions)
  // likeUser → notif like, onUserUpdated → notif match, onMessageCreated → notif message

  /**
   * Marquer une notification comme lue
   */
  async markAsRead(notifId) {
    await updateDoc(doc(db, 'notifications', notifId), { read: true });
  },

  /**
   * Marquer toutes les notifications comme lues
   */
  async markAllAsRead(notifications) {
    const unread = notifications.filter((n) => !n.read);
    if (unread.length === 0) return;

    const batch = writeBatch(db);
    unread.forEach((n) => {
      batch.update(doc(db, 'notifications', n.id), { read: true });
    });
    await batch.commit();
  },
};

export default notificationService;
